import axios from 'axios';
import {
  AuthResponse,
  LoginData,
  DashboardOverview,
  FinancesData,
  HealthData,
  FamilyData,
  GoalsData
} from '../types';

// Определяем платформу (web или мобильное приложение)
const isCapacitorNative = () => {
  try {
    // @ts-ignore
    return window.Capacitor?.isNativePlatform?.() || false;
  } catch {
    return false;
  }
};

// Продакшен URL для мобильного приложения
const PRODUCTION_API_URL = 'https://avatarme.ru';

// В development используем http://localhost:5001, в production - относительный путь через Nginx
// На мобилке всегда используем полный URL продакшена
const API_BASE_URL = isCapacitorNative() 
  ? PRODUCTION_API_URL 
  : (process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5001'));

// Логируем какой URL используется (для отладки)
console.log('[API] Platform:', isCapacitorNative() ? 'Native (Capacitor)' : 'Web');
console.log('[API] Base URL:', API_BASE_URL || '(relative)');

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 15000, // 15 секунд таймаут
});

// Request interceptor to add auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  console.log('[API] Request:', config.method?.toUpperCase(), config.url);
  return config;
});

// Response interceptor для логирования ошибок
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('[API] Error:', error.message);
    if (error.response) {
      console.error('[API] Status:', error.response.status);
      console.error('[API] Data:', error.response.data);
    } else if (error.request) {
      console.error('[API] No response received - network error or CORS');
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: async (data: LoginData): Promise<AuthResponse> => {
    const response = await api.post('/api/auth/login', data);
    return response.data;
  },

  getProfile: async () => {
    const response = await api.get('/api/auth/profile');
    return response.data;
  },
};

// Dashboard API
export const dashboardAPI = {
  getOverview: async (): Promise<DashboardOverview> => {
    const response = await api.get('/api/dashboard');
    return response.data;
  },

  getFinances: async (): Promise<FinancesData> => {
    const response = await api.get('/api/dashboard/finances');
    return response.data;
  },

  getHealth: async (): Promise<HealthData> => {
    const response = await api.get('/api/dashboard/health');
    return response.data;
  },

  getFamily: async (): Promise<FamilyData> => {
    const response = await api.get('/api/dashboard/family');
    return response.data;
  },

  getGoals: async (): Promise<GoalsData> => {
    const response = await api.get('/api/dashboard/goals');
    return response.data;
  },
};

// AI Goals API
export const aiGoalsAPI = {
  manageGoals: async (message: string, chatHistory: any[] = []) => {
    const response = await api.post('/api/ai/manage-goals', {
      message,
      chatHistory
    });
    return response.data;
  },
};

// Tasks API
export const tasksAPI = {
  reorder: async (taskIds: number[], movedTask?: { id: number; status: string; completedAt: string | null }) => {
    const response = await api.post('/api/tasks/reorder', { taskIds, movedTask });
    return response.data;
  },
};

export default api;
